import { useCallback, useState } from 'react';
import { i18n } from 'utils/setupTranslations';
import { SamplesLanguages } from 'types/enums';
import { useLocation } from 'react-router-dom';
import { LanguageDropdownOption } from './types';

const DefaultLanguageOption: LanguageDropdownOption = {
    language: SamplesLanguages.EN,
    label: 'English',
};

export const DropdownOptions: LanguageDropdownOption[] = [
    DefaultLanguageOption,
    { language: SamplesLanguages.FR, label: 'Français' },
    { language: SamplesLanguages.ES, label: 'Español' },
];

export const useLanguageDropdown = () => {
    const [selectedOption] = useState<LanguageDropdownOption>(
        DropdownOptions.find((option) => option.language === i18n.locale) ||
            DefaultLanguageOption,
    );

    const location = useLocation();

    const handleLanguageChange = useCallback(
        (newSelectedOption: LanguageDropdownOption) => {
            const urlLocale =
                newSelectedOption.language === SamplesLanguages.EN
                    ? ''
                    : `/${newSelectedOption.language}`;

            const newPath = `${urlLocale}${location.pathname}`;

            window.location.pathname = newPath;
        },
        [location.pathname],
    );

    return {
        selectedOption,
        handleLanguageChange,
    };
};
